import { render, staticRenderFns } from "./NewQCStep4.vue?vue&type=template&id=4b889390&scoped=true&"
import script from "./NewQCStep4.vue?vue&type=script&lang=js&"
export * from "./NewQCStep4.vue?vue&type=script&lang=js&"
import style0 from "./NewQCStep4.vue?vue&type=style&index=0&id=4b889390&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b889390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VCheckbox,
  VForm,
  VProgressCircular,
  VSelect,
  VTextarea,
})
